import styled, { css } from 'styled-components';

export const RootStyled = styled.div<{ withRoundedBorder?: boolean; variant?: string }>`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 20px;

  ${({ withRoundedBorder }) =>
    withRoundedBorder &&
    css`
      border-radius: 4px;
    `};

  ${({ variant, theme }) => {
    switch (variant) {
      case 'dark':
        return css`
          background-color: ${theme.colors.secondary.onContainer} !important;
        `;

      case 'light':
      default:
        return css`
          background-color: ${theme.colors.neutral.container} !important;
        `;
    }
  }}
`;
